<template>
  <el-form>
    <div class="row">
      <div class="col-md-8 col-12">
        <el-form-item
          :label="L10n('search')"
          class="material-style"
        >
          <select-response-auto-complete
            :model="itemID"
            @update:model="$emit('update:itemID', $event)"
            @on-change="$emit('on-changed', $event)"
            :columns="columns"
            api="SalesOrders/GetAllDynamic"
            :selected="selected"
            searchAllColumns
            :fields="{id: 'id', title: 'rfqid' }"
            :orderBy="{ fields: 'id', order: 'desc' }"
            :filters="`poStillOpen == ${poStillOpen}`"
            :initTemplateFilter="initTemplateFilter"

          >
          </select-response-auto-complete>
        </el-form-item>
      </div>
      <div class="col-md-4 col-6 d-flex justify-content-end align-items-center">
        <button
          type="button"
          class="btn btn-size-s btn-mobile-full"
          @click="handleAddNew">
          <i class="fas fa-plus"/> {{L10n('add-a-quote')}}
        </button>
      </div>
    </div>
  </el-form>
</template>

<script>
export default {
  name: 'ToolsPanel',
  props: {
    itemID: { required: true },
    poStillOpen: { type: Boolean, required: true }
  },
  computed: {
    columns () {
      return [
        { title: this.L10n('po-date'), value: 'poDate', type: 'date' },
        { title: this.L10n('po'), value: 'po', originField: 'rfq.po', type: 'string' },
        { title: this.L10n('bax-po'), value: 'baxpo', originField: 'baxpo', type: 'string' },
        { title: this.L10n('supplier'), value: 'supplierCompanyName', originField: 'supplierCompany.name', type: 'string' },
        { title: this.L10n('customer'), value: 'customerCompanyName', originField: 'rfq.customerCompany.name', type: 'string' },
        { title: this.L10n('rfq-type'), value: 'rfqTypeTitle', originField: 'rfq.rfqType.title', type: 'string' },
        { title: this.L10n('rfq-id'), value: 'rfqid', originField: 'rfqid', type: 'string' },
        { title: this.L10n('po-still-open'), value: 'poStillOpen', originField: 'poStillOpen', type: 'boolean' }
      ]
    },
    selected () {
      return [
        'id', 'rfqid', 'rfq.rfqType.title as rfqTypeTitle', 'supplierCompany.name as supplierCompanyName',
        'rfq.customerCompany.name as customerCompanyName', 'rfq.po as po', 'rfq.poDate as poDate',
        'baxpo', 'employee.name as employeeName', 'poStillOpen'
      ].join(',')
    },
    initTemplateFilter () {
      // eslint-disable-next-line
      return this.itemID ? `id == ${this.itemID}` : '${data.fields.id} == ${data.value}'
    }
  },
  methods: {
    handleAddNew () {
      this.$emit('on-add-new')
    }
  }
}
</script>
